import { Link } from 'react-router-dom';
import { useLanguage } from '../../shell/language-context';

// Catch-all route (CB-D2).
export function NotFoundScreen() {
  const { t } = useLanguage();
  return (
    <div className="empty" style={{ paddingTop: 60 }}>
      <div className="empty__icon" aria-hidden="true">
        🔍
      </div>
      <h1 className="empty__title">{t('notfound.title')}</h1>
      <p className="empty__body">{t('notfound.body')}</p>
      <Link to="/" className="btn">
        {t('user.nav.home')}
      </Link>
    </div>
  );
}
